/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update a notification
 * @export
 * @interface UpdateNotificationRequest
 */
export interface UpdateNotificationRequest {
    /**
     * Updated notification message
     * @type {string}
     * @memberof UpdateNotificationRequest
     */
    message?: string;
    /**
     * Updated event-specific data
     * @type {{ [key: string]: any; }}
     * @memberof UpdateNotificationRequest
     */
    metadata?: { [key: string]: any; } | null;
    /**
     * Mark notification as read at this time
     * @type {Date}
     * @memberof UpdateNotificationRequest
     */
    readAt?: Date | null;
}

/**
 * Check if a given object implements the UpdateNotificationRequest interface.
 */
export function instanceOfUpdateNotificationRequest(value: object): value is UpdateNotificationRequest {
    return true;
}

export function UpdateNotificationRequestFromJSON(json: any): UpdateNotificationRequest {
    return UpdateNotificationRequestFromJSONTyped(json, false);
}

export function UpdateNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'readAt': json['readAt'] == null ? undefined : (new Date(json['readAt'])),
    };
}

export function UpdateNotificationRequestToJSON(json: any): UpdateNotificationRequest {
    return UpdateNotificationRequestToJSONTyped(json, false);
}

export function UpdateNotificationRequestToJSONTyped(value?: UpdateNotificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'metadata': value['metadata'],
        'readAt': value['readAt'] == null ? undefined : ((value['readAt'] as any).toISOString()),
    };
}

